import _classCallCheck from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
var $e40ea825a81a3709$export$52baac22726c72bf = /*#__PURE__*/function (_Set) {
  _inherits($e40ea825a81a3709$export$52baac22726c72bf, _Set);
  function $e40ea825a81a3709$export$52baac22726c72bf(keys, anchorKey, currentKey) {
    var _this;
    _classCallCheck(this, $e40ea825a81a3709$export$52baac22726c72bf);
    _this = _possibleConstructorReturn(this, _getPrototypeOf($e40ea825a81a3709$export$52baac22726c72bf).call(this, keys));
    if (keys instanceof $e40ea825a81a3709$export$52baac22726c72bf) {
      _this.anchorKey = anchorKey !== null && anchorKey !== void 0 ? anchorKey : keys.anchorKey;
      _this.currentKey = currentKey !== null && currentKey !== void 0 ? currentKey : keys.currentKey;
    } else {
      _this.anchorKey = anchorKey !== null && anchorKey !== void 0 ? anchorKey : null;
      _this.currentKey = currentKey !== null && currentKey !== void 0 ? currentKey : null;
    }
    return _this;
  }
  return $e40ea825a81a3709$export$52baac22726c72bf;
}(_wrapNativeSuper(Set));
export { $e40ea825a81a3709$export$52baac22726c72bf as Selection };